'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var outletProductOverviewComponent = exports.outletProductOverviewComponent = {
    template: require('./outlet-product-overview.html'),
    bindings: {
        model: '<',
        context: '<',
        getProducts: '&',
        parentState: '<',
        filterCategories: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$stateParams", "productService", "queryStringHelper", "$state", "Enums", "$window", "cartService", "gettextCatalog", "exceptionService", "$timeout", "Analytics", "dialogService", function controller($scope, $stateParams, productService, queryStringHelper, $state, Enums, $window, cartService, gettextCatalog, exceptionService, $timeout, Analytics, dialogService) {
        'ngInject';

        var vm = this;
        vm.viewMode = window.localStorage.getItem('viewMode') || 'list';
        vm.filternavFolderClass = '';
        vm.changeViewMode = changeViewMode;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.goToPage = goToPage;
        vm.changeSorting = changeSorting;
        vm.changeFilters = changeFilters;
        vm.clearFilter = clearFilter;
        vm.clearFilters = clearFilters;
        vm.filternavFolder = filternavFolder;
        vm.noItemsMessage = null;
        vm.$onInit = init;
        vm.isMobile = false;
        vm.updateQuantity = updateQuantity;
        vm.onChangeQuantity = onChangeQuantity;
        vm.productsQuantityChanged = false;
        vm.addingProducts = false;
        vm.getProductDiscounts = getProductDiscounts;
        $scope.forms = {};

        /* view mode */
        function init() {
            createNoItemsMessage();
            vm.isMobile = $window.innerWidth < 768;
            setPaging();

            //update quantity on enter
            angular.element($window).on('keydown', function (event) {
                if (event.which === 13 && vm.addingProducts !== true) {
                    vm.updateQuantity();
                }
            });
        }

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function setPaging() {
            vm.model.paging.itemsPerPage = parseInt(window.sessionStorage.getItem('pageSize')) || parseInt($stateParams.pageSize);
        }

        function createNoItemsMessage() {
            if (!vm.model.productsAvailableForContext) {
                switch ($state.current.name) {
                    case 'seller.discounts' || 'general.discounts':
                        vm.noItemsMessage = gettextCatalog.getString('There are currently no discounts available');
                        break;
                    default:
                        vm.noItemsMessage = gettextCatalog.getString('There are currently no products available');
                }
            }
        }

        /* change view mode */
        function changeViewMode(viewMode) {
            // set local storage
            window.localStorage.setItem('viewMode', viewMode);
            vm.viewMode = viewMode;
        }

        /* change paging */
        function changeItemsPerPage(itemsPerPage) {
            vm.model.isLoading = true;
            vm.model.paging.itemsPerPage = itemsPerPage;
            //cache the paging
            window.sessionStorage.setItem('pageSize', itemsPerPage);
            $state.go('.', { page: 1, pageSize: itemsPerPage });
        }

        function goToPage(page) {
            if ($scope.forms.productOverviewForm.$dirty === true) {
                dialogService.unsavedChanges().then(function () {
                    vm.isOpen = false;
                    vm.model.isLoading = true;
                    if (page === 0 || page > vm.model.paging.pageCount) {
                        return;
                    }
                    $state.go('.', { page: page });
                }, function () {
                    return false;
                });
            } else {
                vm.isOpen = false;
                vm.model.isLoading = true;
                if (page === 0 || page > vm.model.paging.pageCount) {
                    return;
                }
                $state.go('.', { page: page });
            }
        }

        /* sorting changed */
        function changeSorting(sortProperty) {
            //set the new sorting
            var sortAscByDefault = sortProperty.defaultSorting === 'asc';
            vm.model.sorting.sortAsc = sortProperty.value === vm.model.sorting.sortProperty ? !vm.model.sorting.sortAsc : sortAscByDefault;
            vm.model.sorting.sortProperty = sortProperty.value;

            // put the new properties in local storage
            window.localStorage.setItem($state.current.name + '-sortProperty', sortProperty.value);
            window.localStorage.setItem($state.current.name + '-sortAsc', vm.model.sorting.sortAsc);

            //go to the page with the correct sorting
            $state.go('.', {
                page: 1,
                sortProperty: sortProperty.value,
                sortAsc: vm.model.sorting.sortAsc
            });
        }

        /* filters changed TODO PUT IN SERVICE */
        function changeFilters(filter, category) {

            var categorySearch = category.items.find(function (filterHierarchyCategoryItem) {
                return filterHierarchyCategoryItem.isSelected === true;
            });

            //if the same category is selected do nothing
            if (filter.id === categorySearch.id) {
                return;
            }

            vm.model.isLoading = true;
            Analytics.trackEvent('Filter', 'setFilterOutletOverview', filter.name, 0, true);

            // select or unselect
            filter.isSelected = !filter.isSelected;

            //if the category is a link navigate to that page
            if (category.isLink) {
                navigateToPage(filter, category);
                return;
            }

            var filterParam = '';

            // on select/unselect, select/unselect all the children when the category is a parent
            if (filter.children && filter.children.length && !filter.isSelected) {
                filter.children.forEach(function (child) {
                    child.isSelected = false;
                    child.children.forEach(function (child) {
                        child.isSelected = false;
                    });
                });
            } else if (filter.children && filter.children.length && filter.isSelected) {
                filter.children.forEach(function (child) {
                    child.isSelected = true;
                    child.children.forEach(function (child) {
                        child.isSelected = true;
                    });
                });
            }

            // create the query string
            filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories);
            // navigate to the route with craeted filter params
            $state.go('.', { page: 1, filter: filterParam });
        }

        /* clear the filter */
        function clearFilter(filter, category) {
            vm.model.isLoading = true;

            if (category.isLink) {
                return;
            }

            // when category is hierarchical, don't get isSelected from the items, but set the query string param directly
            var filterParam = '';
            if (!vm.model.filter.isCategoryHierarchical(category.id)) {
                vm.model.filter.clearFilter(category.id, filter.id);
                filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories);
            } else {
                var selectedId = vm.model.filter.getParentIdOfChildCategory(category.id, filter.id);
                filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories, category.id, selectedId);
            }

            $state.go('.', { page: 1, filter: filterParam });
        }

        /* reset the page when clearing the filters */
        function clearFilters() {
            vm.model.isLoading = true;

            $state.go('.', {
                page: 1,
                pageSize: 24,
                sortProperty: '',
                sortAsc: true,
                filter: ''
            });
        }

        /* On filter changed, navigate to correct page */
        function navigateToPage(filter) {
            $state.go('general.outlet.category', {
                categoryId: filter.id,
                filter: $stateParams.filter === Enums.otherCategoryType.discountsOnly.id + '_1' ? Enums.otherCategoryType.discountsOnly.id + '_1' : '',
                page: 1,
                noReloadFilter: true
            });
        }

        /* toggle visibility sorting or filters */
        function filternavFolder(folderClass) {
            if (folderClass === vm.filternavFolderClass) {
                folderClass = '';
            }
            vm.filternavFolderClass = folderClass;
        }

        /* add products to the shoppingcart */
        function updateQuantity() {
            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;

            var productFilterNoPanacee = vm.model.products.filter(function (x) {
                return x.productTypeCode !== 'panacee';
            });

            cartService.updateCartOverview(productFilterNoPanacee).then(function (shoppingCartProducts) {

                if ($scope.forms.productOverviewForm) {
                    $scope.forms.productOverviewForm.$setPristine();
                }

                vm.addingProducts = false;
                vm.productsAdded = true;
                vm.addToCartEnabled = true;

                vm.model.products.map(function (product) {
                    return product = product.getCartFields(product, shoppingCartProducts);
                });

                cartService.setAddedProducts([]);
                cartService.addProductToCartAnalytics();

                $timeout(function () {
                    vm.isOpen = false;
                    vm.productsAdded = false;
                }, 5000);
            }).catch(function () {
                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                vm.hasError = true;
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
                exceptionService.logException(msg);
            });
        }

        /* quantity of product changed */
        function onChangeQuantity($event) {
            if ($event) {
                cartService.addProductToAddedProductsList($event);
            }

            if (!vm.addingProducts) {
                vm.isOpen = true;
                vm.productsAdded = false;
                vm.productsQuantityChanged = true;
            }
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/outlet/components/outlet-product-overview.js
// module id = 956
// module chunks = 0